import type { UserProgress } from '@repo/lib';

export type RawUserProgress = Omit<UserProgress, 'role'> & {
  role?: 'admin' | 'user' | 'logged-out';
};

export function normalizeUserProgress(
  progress: RawUserProgress | null | undefined
): UserProgress | null {
  if (!progress) {
    return null;
  }
  const role: 'admin' | 'user' = progress.role === 'admin' ? 'admin' : 'user';
  const subscriptionStatus = progress.subscriptionStatus ?? 'stargazer';
  return { ...progress, role, subscriptionStatus };
}
